import { Injectable } from '@angular/core';
import { HttpClient,HttpHeaders} from '@angular/common/http';
import { environment } from '../../environments/environment';


import {Observable} from 'rxjs/Observable';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/catch';
import 'rxjs/add/observable/throw';

@Injectable({
  providedIn: 'root'
})
export class AuthService {
  httpOptions: any = {
    headers: new HttpHeaders({
     'Content-Type':  'application/json',
     'Access-Control-Allow-Origin': '*'
    })
 }
  private _createuserUrl = "http://localhost:5000/api/create/";

  constructor(private http: HttpClient) { }

  registerUser(user) {
    return this.http.post<any>(this._createuserUrl, user)
  }

  partnerLogin(username,password,usertype): any{
    let data={"username":username,"password":password} 
    if(usertype=='a')
    {
      return this.http.post(environment.apiURL+"/auth/adminLogin",data,this.httpOptions)
      .catch(this.handleError); 
    }
    else{
      return this.http.post(environment.apiURL+"/auth/partnerLogin",data,this.httpOptions)
      .catch(this.handleError); 
    }
   
 
}  

handleError(error: Response) {
  console.log(error);
  return Observable.throw(error);
}
}
